import React, { Component } from 'react';
import Button from './../CustomButton/CustomButton';

export default class FolioCellRenderer extends Component {
  invokeParentMethodEdit = () => {
    this.props.context.componentParent.editRecord(
      this.props.data._id || this.props.data.id
    );
  };

  render() {
    return (
      <div className="actions-right">
        {this.props.data.delete === true ? (
          <span style={{ color: 'red', fontSize: '16px' }}>Cancelada</span>
        ) : (
          <Button
            onClick={this.invokeParentMethodEdit}
            bsStyle="warning"
            simple
          >
            Editar
          </Button>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/SalesActionsButtonCellRenderer.jsx